import * as types from './types'
import { Dictionary } from 'lodash'
import { GridEntity } from '../query/types'

export const setBaseUrl = (url: string): types.GlobalOptionsActionTypes => {
    return {
        type: types.GLOBAL_CHANGE_URL,
        url: url
    }
}

export const setDrawer = (state: boolean): types.GlobalViewActionTypes => {
    return {
        type: types.GLOBAL_SET_DRAWER,
        open: state,
    }
}

export const changePage = (route: string, search?: string): types.GlobalViewActionTypes => {
    return {
        type: types.GLOBAL_CHANGE_PAGE,
        route,
        search,
    }
}

export const navigate = (route: string): types.GlobalViewActionTypes => {
    return {
        type: types.GLOBAL_NAVIGATE,
        route: route,
    }
}

export const changePageTitle = (title: string) => {
    return {
        type: types.GLOBAL_CHANGE_TITLE,
        title: title,
    }
}

export const setLoginSuccess = (token: types.OAuthToken): types.GlobalAuthActionTypes => {
    return {
        type: types.GLOBAL_LOGIN_SUCCESS,
        token,
    }
}

export const doLogout = (): types.GlobalAuthActionTypes => {
    return {
        type: types.GLOBAL_LOGOUT_START
    }
}

export const doLogoutFinish = (): types.GlobalAuthActionTypes => {
    return {
        type: types.GLOBAL_LOGOUT_END
    }
}

export const removeSnackbar = (key: string): types.GlobalViewActionTypes => {
    return {
        type: types.GLOBAL_REMOVE_SNACKBAR,
        key: key
    }
}

export const addSnackbar = (notification: string, key: string, options: any = {}): types.GlobalViewActionTypes => {
    return {
        type: types.GLOBAL_ADD_SNACKBAR,
        notification: {
            message: notification,
            key: key || (new Date().getTime() + Math.random()).toString(),
            options: {
                ...options, autoHideDuration: 5000,
            },
            dismissed: false
        }
    }
}

export const closeSnackbar = (key: string): types.GlobalViewActionTypes => {
    return {
        type: types.GLOBAL_CLOSE_SNACKBAR,
        key: key
    }
}

export const closeModal = () => {
    return {
        type: types.GLOBAL_HIDE_MODAL
    }
}

export const loadGrids = (resourceNames: string[]): types.GlobalGridsActionTypes => {
    return {
        type: types.GLOBAL_LOAD_GRIDS,
        resourceNames
    }
}

export const addGrid = (grid: GridEntity): types.GlobalGridsActionTypes => {
    return {
        type: types.GLOBAL_ADD_GRID,
        grid
    }
}

export const removeGrid = (id: string): types.GlobalGridsActionTypes => {
    return {
        type: types.GLOBAL_REMOVE_GRID,
        id
    }
}

export const setGrids = (grids: Dictionary<Dictionary<GridEntity>>): types.GlobalGridsActionTypes => {
    return {
        type: types.GLOBAL_SET_GRIDS,
        grids
    }
}
